module.exports = __webpack_public_path__ + "static/img/风道巷道形变监测.63b3be9d.png";